import profile1 from '/public/siteImages/iOSTheme/profile/profile1.png';
import profile2 from '/public/siteImages/iOSTheme/profile/profile2.png';
import profile3 from '/public/siteImages/iOSTheme/profile/profile3.png';
import profile4 from '/public/siteImages/iOSTheme/profile/profile4.png';

export {
    profile1,
    profile2,
    profile3,
    profile4
}